import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { styledDefaultColDef, createAvatarNameRenderer } from '../../../../extras/cellRenderers';

const getFullName = (params) => {
  return params?.data?.User?.firstName
    ?  params?.data?.User?.firstName + ' ' +  params?.data?.User?.lastName
    : '';
};

const AvatarNameLink = createAvatarNameRenderer(
  (p) => p?.data?.User?.firstName,
  (p) => p?.data?.User?.lastName
);

const NameGetter = (params) => {
  const history = useHistory();

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', height: '100%', cursor: 'pointer' }}
      onClick={() => {
        history.push({
          pathname: '/all-almax-students/user-details',
          state: { userParams: params.data },
        });
      }}
    >
      <AvatarNameLink {...params} />
    </div>
  );
};

export const columnDefs = (props = {}) => [
  {
    headerName: 'ID',
    field: 'id',
    resizable: true,
    width: 200,
    tooltipField: 'id',
    valueGetter: (params) =>
      params?.data?.userId ?? params?.data?.User?.id ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.userId ?? params?.data?.User?.id ?? 'N/A',
  },
  {
    headerName: 'Name',
    field: 'name',
    resizable: true,
    width: 200,
    tooltipField: 'name',
    // valueGetter: (params) => {
    //   const user = params?.data?.User;
    //   if (user?.firstName || user?.lastName) {
    //     return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    //   }
    //   return 'N/A';
    // },
    valueGetter: (params) => getFullName(params.data.user) || 'N/A',

    tooltipValueGetter: (params) => {
      const user = params?.data?.User;
      if (user?.firstName || user?.lastName) {
        return `${user.firstName || ''} ${user.lastName || ''}`.trim();
      }
      return 'N/A';
    },
    cellRenderer: NameGetter,
  },
  {
    headerName: 'Email',
    field: 'email',
    resizable: true,
    width: 220,
    tooltipField: 'email',
    valueGetter: (params) =>
      params?.data?.User?.email ??
      params?.data?.UserAbCatReport?.email ??
      'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.email ??
      params?.data?.UserAbCatReport?.email ??
      'N/A',
  },
  {
    headerName: 'Enrollment Date',
    field: 'signUpDate',
    resizable: true,
    width: 180,
    tooltipField: 'signUpDate',
    valueGetter: (params) => {
      const date = params?.data?.User?.createdOn || params?.data?.createdAt;
      return date ? new Date(date).toLocaleDateString() : 'N/A';
    },
    tooltipValueGetter: (params) => {
      const date = params?.data?.User?.createdOn || params?.data?.createdAt;
      return date ? new Date(date).toLocaleString() : 'N/A';
    },
  },
  {
    headerName: 'Plan Type',
    field: 'planType',
    resizable: true,
    width: 140,
    tooltipField: 'planType',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.planType ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.planType ?? 'N/A',
  },
  {
    headerName: 'Course Type',
    field: 'courseType',
    resizable: true,
    width: 140,
    tooltipField: 'courseType',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.courseType ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.courseType ?? 'N/A',
  },
  {
    headerName: 'Subplan Type',
    field: 'subPlanType',
    resizable: true,
    width: 140,
    tooltipField: 'subPlanType',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.subPlanType ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.subPlanType ?? 'N/A',
  },
  {
    headerName: 'Cohort Name',
    field: 'cohortName',
    resizable: true,
    width: 180,
    tooltipField: 'cohortName',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.cohortName ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.cohortName ?? 'N/A',
  },
  {
    headerName: 'AlmaX Cohort Name',
    field: 'almaxCohortName',
    resizable: true,
    width: 180,
    tooltipField: 'almaxCohortName',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.almaxCohortName ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.almaxCohortName ?? 'N/A',
  },
  {
    headerName: 'Phone Verified',
    field: 'isPhoneVerified',
    resizable: true,
    width: 150,
    cellRenderer: (params) => {
      const verified = params?.data?.User?.isPhoneVerified;
      if (verified === undefined || verified === null) return null;
      return (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          {verified ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#2563EB' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#2563EB"/><path d="M4 7L6 9.5L10 5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Verified
            </span>
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#9CA3AF' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#D1D5DB"/><path d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/></svg>
              Unverified
            </span>
          )}
        </div>
      );
    },
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
